import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.feature-sets.CreateCreditCardBillView`

export default defineMessages({
  addPaymentMethodModalTitle: {
    id: `${scope}.addPaymentMethodModalTitle`,
    defaultMessage: 'Add payment method to {provider}',
  },
  attachInvoiceModalTitle: {
    id: `${scope}.attachInvoiceModalTitle`,
    defaultMessage: 'Attach invoice to items',
  },
  attachCancelButton: {
    id: `${scope}.attachCancelButton`,
    defaultMessage: 'Cancel',
  },
  attachConfirmButton: {
    id: `${scope}.attachConfirmButton`,
    defaultMessage: 'Attach',
  },
})
